// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-icon,.provider-icon img{border-radius:20%}.provider-icon--labelled{overflow:hidden;height:100%;display:flex;justify-content:center;align-items:center;font-size:1.2rem}.provider-icon--labelled.timeline__provider-block__logo{font-size:.7rem}.provider-icon .ribbon{position:absolute;top:6px;right:-10px;width:100%;text-align:center;background-color:#d5d5d5;color:#1c252f;font-size:9px;font-weight:700;padding:0 4px;border-radius:0 0 0 5px;z-index:1;transform:rotate(45deg)}", ""]);
// Exports
module.exports = exports;
